import { type DefaultHeaders } from "@/compositions/useAxios/types.ts";

const DEFAULT_HEADERS: DefaultHeaders = {
  "Content-Type": "application/json",
  "Consumer-Key": import.meta.env.VITE_CONSUMER_KEY_HEADER,
  "SOURCE-SYSTEM": "STANDALONE_PLATFORM"
};

export { DEFAULT_HEADERS };
